<template>
    <div class="documents tab-content">
        <!-- Current Service Under Development -->
        <el-tabs v-model="activeName" @tab-click="handleClick">

          <!-- SOP -->
          <el-tab-pane :disabled="!engagementPermission.viewDocumentsSOP" :label="$t('e_tab_documents_sop')" name="first">
            <el-card>
              <div v-if="documents.sop" class="item">
                <div v-if="documents.sop.editMessage" class="item__note">
                  <el-alert
                    title="Information"
                    type="warning"
                    :description="documents.sop.editMessage"
                    show-icon>
                  </el-alert>
                </div>
                <div class="item__title">
                  {{documents.sop.name}}
                  <div v-if="documents.sop.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('e_tab_documents_accept')}}</el-tag>
                  </div>
                  <div v-if="documents.sop.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('e_tab_documents_reject')}}</el-tag>
                  </div>
                </div>
                <div v-html="documents.sop.content" class="item__content"></div>

                <el-dropdown v-for="item in documents.sop.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFiles(item.url, item.originalName)" class="download-btn" icon="el-icon-upload">{{$t('project_tab_files_first_download')}}</el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<div v-for="item in documents.sop.files" :key="item.id" class="item__file">-->
                  <!--<i class="el-icon-link"></i>-->
                  <!--<a :href="`${item.url}?mode=attachment`">{{item.name}}</a>-->
                <!--</div>-->

                <!-- confirmation -->
                <div v-if="documents.sop.level !== 0 && !documents.sop.isAccepted && !documents.sop.isRejected" style="margin-bottom: 20px; text-align: right;">
                  <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                  <span style="font-size: 12px;">{{$t('e_tab_documents_sop_clicking')}}</span>
                </div>

                <div v-if="documents.sop.level !== 0 && !documents.sop.isAccepted && !documents.sop.isRejected" class="item__btn">
                  <el-button @click="openLater(1, documents.sop.date)" v-if="(documents.sop.date && !documents.sop.isLater && !documents.sop.isAccepted && !documents.sop.isRejected && documents.sop.level !== 0)" type="info" size="mini">{{$t('e_tab_documents_later')}}</el-button>
                  <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(1)">{{$t('e_tab_documents_accept')}}</el-button>
                  <el-button type="danger" size="mini" @click="reject(1)">{{$t('e_tab_documents_reject')}}</el-button>
                </div>
              </div>
              <div v-else>{{$t('general_thereIsNoData')}}</div>
            </el-card>
          </el-tab-pane>

          <!-- Policy -->
          <el-tab-pane :disabled="!engagementPermission.viewDocumentsPolicy" :label="$t('e_tab_documents_policy')" name="second">
            <el-card>
              <div v-if="documents.policy" class="item">
                <div v-if="documents.policy.editMessage" class="item__note">
                  <el-alert
                    title="Information"
                    type="warning"
                    :description="documents.policy.editMessage"
                    show-icon>
                  </el-alert>
                </div>
                <div class="item__title">
                  {{documents.policy.name}}
                  <div v-if="documents.policy.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('e_tab_documents_accept')}}</el-tag>
                  </div>
                  <div v-if="documents.policy.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('e_tab_documents_reject')}}</el-tag>
                  </div>
                </div>
                <div v-html="documents.policy.content" class="item__content"></div>

                <el-dropdown v-for="item in documents.policy.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<div v-for="item in documents.policy.files" :key="item.id" class="item__file">-->
                  <!--<i class="el-icon-link"></i>-->
                  <!--<a :href="`${item.url}?mode=attachment`">{{item.name}}</a>-->
                <!--</div>-->

                <!-- confirmation -->
                <div v-if="documents.policy.level !== 0 && !documents.policy.isAccepted && !documents.policy.isRejected" style="margin-bottom: 20px; text-align: right;">
                  <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                  <span style="font-size: 14px;">{{$t('e_tab_documents_policy_clicking')}}</span>
                </div>

                <div v-if="documents.policy.level !== 0 && !documents.policy.isAccepted && !documents.policy.isRejected" class="item__btn">
                  <el-button @click="openLater(2, documents.policy.date)" v-if="(documents.policy.date && !documents.policy.isLater && !documents.policy.isAccepted && !documents.policy.isRejected && documents.policy.level !== 0)" type="info" size="mini">{{$t('e_tab_documents_later')}}</el-button>
                  <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(2)">{{$t('e_tab_documents_accept')}}</el-button>
                  <el-button type="danger" size="mini" @click="reject(2)">{{$t('e_tab_documents_reject')}}</el-button>
                </div>
              </div>
              <div v-else>{{$t('general_thereIsNoData')}}</div>
            </el-card>
          </el-tab-pane>

          <!-- Healt Safety -->
          <el-tab-pane :disabled="!engagementPermission.viewDocumentsHealthSafety" :label="$t('e_tab_documents_healthSafety')" name="third">
            <el-card>
              <div v-if="documents.healthsafety" class="item">
                <div v-if="documents.healthsafety.editMessage" class="item__note">
                  <el-alert
                    title="Information"
                    type="warning"
                    :description="documents.healthsafety.editMessage"
                    show-icon>
                  </el-alert>
                </div>
                <div class="item__title">
                  {{documents.healthsafety.name}}
                  <div v-if="documents.healthsafety.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('e_tab_documents_accept')}}</el-tag>
                  </div>
                  <div v-if="documents.healthsafety.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('e_tab_documents_reject')}}</el-tag>
                  </div>
                </div>
                <div v-html="documents.healthsafety.content" class="item__content"></div>

                <el-dropdown v-for="item in documents.healthsafety.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<div v-for="item in documents.healthsafety.files" :key="item.id" class="item__file">-->
                  <!--<i class="el-icon-link"></i>-->
                  <!--<a :href="`${item.url}?mode=attachment`">{{item.name}}</a>-->
                <!--</div>-->

                <!-- confirmation -->
                <div v-if="documents.healthsafety.level !== 0 && !documents.healthsafety.isAccepted && !documents.healthsafety.isRejected" style="margin-bottom: 20px; text-align: right;">
                  <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                  <span style="font-size: 14px;">{{$t('e_tab_documents_healthSafety_clicking')}}</span>
                </div>

                <div v-if="documents.healthsafety.level !== 0 && !documents.healthsafety.isAccepted && !documents.healthsafety.isRejected" class="item__btn">
                  <el-button @click="openLater(3, documents.healthsafety.date)" v-if="(documents.healthsafety.date && !documents.healthsafety.isLater && !documents.healthsafety.isAccepted && !documents.healthsafety.isRejected && documents.healthsafety.level !== 0)" type="info" size="mini">{{$t('e_tab_documents_later')}}</el-button>
                  <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(3)">{{$t('e_tab_documents_accept')}}</el-button>
                  <el-button type="danger" size="mini" @click="reject(3)">{{$t('e_tab_documents_reject')}}</el-button>
                </div>
              </div>
              <div v-else>{{$t('general_thereIsNoData')}}</div>
            </el-card>
          </el-tab-pane>

          <!-- Risk Assesment -->
          <el-tab-pane :disabled="!engagementPermission.viewDocumentsCommercial" :label="$t('e_tab_documents_commercial')" name="fourth">
            <el-card>
              <div v-if="documents.riskAssesment" class="item">
                <div v-if="documents.riskAssesment.editMessage" class="item__note">
                  <el-alert
                    title="Information"
                    type="warning"
                    :description="documents.riskAssesment.editMessage"
                    show-icon>
                  </el-alert>
                </div>
                <div class="item__title">
                  {{documents.riskAssesment.name}}
                  <div v-if="documents.riskAssesment.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('e_tab_documents_accept')}}</el-tag>
                  </div>
                  <div v-if="documents.riskAssesment.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('e_tab_documents_reject')}}</el-tag>
                  </div>
                </div>
                <div v-html="documents.riskAssesment.content" class="item__content"></div>

                <el-dropdown v-for="item in documents.riskAssesment.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<div v-for="item in documents.riskAssesment.files" :key="item.id" class="item__file">-->
                  <!--<i class="el-icon-link"></i>-->
                  <!--<a :href="`${item.url}?mode=attachment`">{{item.name}}</a>-->
                <!--</div>-->

                <!-- confirmation -->
                <div v-if="documents.riskAssesment.level !== 0 && !documents.riskAssesment.isAccepted && !documents.riskAssesment.isRejected" style="margin-bottom: 20px; text-align: right;">
                  <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                  <span style="font-size: 14px;">{{$t('e_tab_documents_commercial_clicking')}}</span>
                </div>

                <div v-if="documents.riskAssesment.level !== 0 && !documents.riskAssesment.isAccepted && !documents.riskAssesment.isRejected" class="item__btn">
                  <el-button @click="openLater(4, documents.riskAssesment.date)" v-if="(documents.riskAssesment.date && !documents.riskAssesment.isLater && !documents.riskAssesment.isAccepted && !documents.riskAssesment.isRejected && documents.riskAssesment.level !== 0)" type="info" size="mini">{{$t('e_tab_documents_later')}}</el-button>
                  <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(4)">{{$t('e_tab_documents_accept')}}</el-button>
                  <el-button type="danger" size="mini" @click="reject(4)">{{$t('e_tab_documents_reject')}}</el-button>
                </div>
              </div>
              <div v-else>{{$t('general_thereIsNoData')}}</div>
            </el-card>
          </el-tab-pane>

          <!-- Envirenmental -->
          <el-tab-pane :disabled="!engagementPermission.viewDocumentsGeneral" :label="$t('e_tab_documents_general')" name="five">
            <el-card>
              <div v-if="documents.envirenmental" class="item">
                <div v-if="documents.envirenmental.editMessage" class="item__note">
                  <el-alert
                    title="Information"
                    type="warning"
                    :description="documents.envirenmental.editMessage"
                    show-icon>
                  </el-alert>
                </div>
                <div class="item__title">
                  {{documents.envirenmental.name}}
                  <div v-if="documents.envirenmental.isAccepted" class="item__status">
                    <el-tag type="success" size="mini">{{$t('e_tab_documents_accept')}}</el-tag>
                  </div>
                  <div v-if="documents.envirenmental.isRejected" class="item__status">
                    <el-tag type="danger" size="mini">{{$t('e_tab_documents_reject')}}</el-tag>
                  </div>
                </div>
                <div v-html="documents.envirenmental.content" class="item__content"></div>

                <el-dropdown v-for="item in documents.envirenmental.files" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.originalName}}</span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="viewFile(item.url, item)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
                    <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
                    <!--<el-dropdown-item @click.native="viewFile(item.url)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>-->
                    <!--<el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<div v-for="item in documents.envirenmental.files" :key="item.id" class="item__file">-->
                  <!--<i class="el-icon-link"></i>-->
                  <!--<a :href="`${item.url}?mode=attachment`">{{item.name}}</a>-->
                <!--</div>-->

                <!-- confirmation -->
                <div v-if="documents.envirenmental.level !== 0 && !documents.envirenmental.isAccepted && !documents.envirenmental.isRejected" style="margin-bottom: 20px; text-align: right;">
                  <el-checkbox v-model="confirmation"></el-checkbox>&nbsp;
                  <span style="font-size: 14px;">{{$t('e_tab_documents_general_clicking')}}</span>
                </div>

                <div v-if="documents.envirenmental.level !== 0 && !documents.envirenmental.isAccepted && !documents.envirenmental.isRejected" class="item__btn">
                  <el-button @click="openLater(5, documents.envirenmental.date)" v-if="(documents.envirenmental.date && !documents.envirenmental.isLater && !documents.envirenmental.isAccepted && !documents.envirenmental.isRejected && documents.envirenmental.level !== 0)" type="info" size="mini">{{$t('e_tab_documents_later')}}</el-button>
                  <el-button :disabled="!confirmation" type="success" size="mini" @click="accept(5)">{{$t('e_tab_documents_accept')}}</el-button>
                  <el-button type="danger" size="mini" @click="reject(5)">{{$t('e_tab_documents_reject')}}</el-button>
                </div>
              </div>
              <div v-else>{{$t('general_thereIsNoData')}}</div>
            </el-card>
          </el-tab-pane>
        </el-tabs>

        <el-dialog
          :title="$t('e_tab_documents_reject_title')"
          :visible.sync="dialogVisible"
          width="50%"
          :before-close="handleClose">

          <span>{{$t('e_tab_documents_reject_text')}}</span>
          <el-input v-model="msg" type="textarea" placeholder=""></el-input>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" size="mini">{{$t('e_tab_documents_reject_cancel')}}</el-button>
            <el-button :disabled="!(msg)" type="primary" @click="rejectModal" size="mini">{{$t('e_tab_documents_reject_send')}}</el-button>
          </span>
        </el-dialog>

      <!--VIEWER-->
      <div v-if="viewerType == 1">
        <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
          <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
        </sweet-modal>
      </div>
      <div v-if="viewerType == 2">
        <div v-show="false" class="images" v-viewer="{movable: true}">
          <img :src="fileUrl" :key="fileUrl" />
        </div>
      </div>
      <div class="mod" v-if="viewerType == 3">
        <div @click="closeMod" class="mod__close">
          <span>x</span>
        </div>
        <Media
                :kind="'video'"
                :controls="true"
                :src="fileUrl"
        >
        </Media>
      </div>
      <div class="mod" v-if="viewerType == 4">
        <div @click="closeMod" class="mod__close">
          <span>x</span>
        </div>
        <Media
                :kind="'audio'"
                :controls="true"
                :src="fileUrl"
        >
        </Media>
      </div>

        <!-- {{documents}} -->
        <!-- <div class="book-mark-block pointer">
          <div>
            <div v-if="bookmarkList.documents" @click="changeBookMark(bookmarkList.documents, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>
            <div v-else @click="changeBookMark(bookmarkList.documents, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>
          </div>
        </div> -->
    </div>
</template>

<script>
  import Media from '@dongido/vue-viaudio'
  import fileImg from '../fileImg'
  import axios from 'axios'
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

  export default {
    name: 'documents',
    components: {
      SweetModal,
      fileImg,
      Media
    },
    props: [
      // 'bookmarkList',
      'selectedRow',
      'engagementPermission'],
    watch: {
      documents: function (val) {
        this.confirmation = false
      },
    },
    data() {
      return {
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
        moment:moment,
        activeName: 'first',

        // reject
        documentId: null,
        typeDocument: null,

        confirmation: false,

        dialogVisible: false,
        msg: '',

        sop: false,
        sopList: [],
        policy: false,
        policyList: [],
        healthsafety: false,
        healthsafetyList: [],
        riskAssesment: false,
        riskAssesmentList: [],
        envirenmental: false,
        envirenmentalList: [],
        viewerType: 0,
        fileUrl: '',
        type: '',
      }
    },
    computed: {
      documents() {
        return this.$store.state.documentsE
      }
    },
    methods: {
      downloadFiles(url, name) {
        // document.location.href = `${url + '/' + name}?mode=attachment`;
        let restOfTheUrl = url.split('https://storage.totalflow.io/')[1] || ''
        // alert(restOfTheUrl)
        let newUrl = `https://storage.totalflow.io/d.php?${restOfTheUrl + '/' + encodeURIComponent(name)}`
        document.location.href = newUrl
      },
      openLater(type, days) {
        let documentId = null;
        let typeDocument = '';
        let reviewPeriod = '';
        switch (type) {
          case 1:
            typeDocument = 'sop';
            documentId = this.documents.sop.id;
            reviewPeriod = this.documents.sop.period;
            break;
          case 2:
            typeDocument = 'policy';
            documentId = this.documents.policy.id;
            reviewPeriod = this.documents.policy.period;
            break;
          case 3:
            typeDocument = 'healthsafety'
            documentId = this.documents.healthsafety.id
            reviewPeriod = this.documents.healthsafety.period;
            break;
          case 4:
            typeDocument = 'riskAssesment'
            documentId = this.documents.riskAssesment.id
            reviewPeriod = this.documents.riskAssesment.period;
            break;
          case 5:
            typeDocument = 'envirenmental'
            documentId = this.documents.envirenmental.id
            reviewPeriod = this.documents.envirenmental.period;
            break;
        }

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/laterDocument?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.$route.query.taskId}&type=${typeDocument}&period=${reviewPeriod}`)
          .then(response => {
            this.$store.dispatch('getDocumentsE', this.$route.query.taskId)

            let msg = 'The review period for this document has been set for ' + days +  ' days. Please confirm your actions within this period, thanks!'
            this.$alert(msg, 'Later', {
              confirmButtonText: 'OK'
            });

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      // select tab
      selectTab(type) {
        switch (type) {
          case 'sop':
            this.activeName = 'first'
            break;
          case 'policy':
            this.activeName = 'second'
            break;
          case 'healthsafety':
            this.activeName = 'third'
            break;
          case 'commercial':
            this.activeName = 'fourth'
            break;
          case 'riskAssesment':
            this.activeName = 'fourth'
            break;
          case 'general':
            this.activeName = 'five'
            break;
          case 'envirenmental':
            this.activeName = 'five'
            break;
        }
      },
      handleClose(done) {
        this.dialogVisible = false
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // changeBookMark(state, companyid, engagementId, taskId){
      //   let data = this.bookmarkList
      //   data.documents = !this.bookmarkList.documents
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios.post(`/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${engagementId}&engagementTaskId=${taskId}`, data)
      //     .then(response => {
      //       if (this.bookmarkList.documents) {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
      //       } else {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
      //       }
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      accept(type) {
        let documentId = null
        let typeDocument = ''
        switch (type) {
          case 1:
            typeDocument = 'sop'
            documentId = this.documents.sop.id
            break;
          case 2:
            typeDocument = 'policy'
            documentId = this.documents.policy.id
            break;
          case 3:
            typeDocument = 'healthsafety'
            documentId = this.documents.healthsafety.id
            break;
          case 4:
            typeDocument = 'riskAssesment'
            documentId = this.documents.riskAssesment.id
            break;
          case 5:
            typeDocument = 'envirenmental'
            documentId = this.documents.envirenmental.id
            break;
        }

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/acceptDocument?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.$route.query.taskId}&type=${typeDocument}&documentId=${documentId}`)
          .then(response => {
            this.$store.dispatch('getDocumentsE', this.$route.query.taskId)
            this.$message({
              type: 'success',
              message: 'Accept'
            });
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      reject(type) {
        switch (type) {
          case 1:
            this.typeDocument = 'sop'
            this.documentId = this.documents.sop.id
            break;
          case 2:
            this.typeDocument = 'policy'
            this.documentId = this.documents.policy.id
            break;
          case 3:
            this.typeDocument = 'healthsafety'
            this.documentId = this.documents.healthsafety.id
            break;
          case 4:
            this.typeDocument = 'riskAssesment'
            this.documentId = this.documents.riskAssesment.id
            break;
          case 5:
            this.typeDocument = 'envirenmental'
            this.documentId = this.documents.envirenmental.id
            break;
        }

        this.dialogVisible = true
      },
      rejectModal() {

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/rejectDocument?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.$route.query.taskId}&type=${this.typeDocument}&documentId=${this.documentId}`, {
          rejectMessage: this.msg
        })
          .then(response => {
            this.dialogVisible = false
            this.$store.dispatch('getDocumentsE', this.$route.query.taskId)
            this.$message({
              type: 'success',
              message: 'Message sent'
            });
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      typeTranslation(type) {
        let documentId = null
        let typeDocument = ''
        switch (type) {
          case 1:
            typeDocument = 'sop'
            documentId = this.documents.sop.id
            break;
          case 2:
            typeDocument = 'policy'
            documentId = this.documents.policy.id
            break;
          case 3:
            typeDocument = 'healthsafety'
            documentId = this.documents.healthsafety.id
            break;
          case 4:
            typeDocument = 'riskAssesment'
            documentId = this.documents.riskAssesment.id
            break;
          case 5:
            typeDocument = 'envirenmental'
            documentId = this.documents.envirenmental.id
            break;
        }
      },
      viewFile(url, file) {
        let win = null;
        console.log(file);
        let type = url.split(".").pop().toUpperCase();
        this.fileUrl = url;
        this.type = this.fileUrl.split(".").pop().toUpperCase();
        switch (type) {
          case "GIF":
          case "JPG":
          case "JPEG":
          case "PNG":
          case "BMP":
            this.viewerType = 2;
            setTimeout(() => {
              console.log("-----", this.$el);
              const viewer = this.$el.querySelector(".images").$viewer;
              viewer.show();
            }, 300);
            break;
          case "MOV":
          case "MP4":
            this.viewerType = 3;
            break;
          case "WMA":
          case "MP3":
          case "WAV":
          case "OGG":
          case "M4A":
            this.viewerType = 4;
            break;
          case "STEP":
          case "STP":
          case "IGES":
          case "IGS":
          case "BREP":
          case "STL":
          case "SAT":
          case "X_T":
          case "X_B":
          case "SLDPRT":
          case "DWG":
          case "DXF":
          case "DWF":
          case "HPGL":
          case "PLT":
          case "CGM":
          case "SVG":
          case "EMF":
          case "WMF":
            this.fileUrl =
              "https://sharecad.org/cadframe/load?url=" + this.fileUrl;
            setTimeout(() => {
              window.open(this.fileUrl);
            }, 300);
            break;
          case "PDF":
            window.open(this.fileUrl);
            break;
          case "DOC":
          case "DOCM":
          case "DOCX":
          case "DOT":
          case "DOTM":
          case "DOTX":
          case "EPUD":
          case "FODT":
          case "HTM":
          case "MHT":
          case "ODT":
          case "OTT":
          case "RTF":
          case "TXT":
          case "DJVU":
          case "XPS":
          case "CSV":
          case "FODS":
          case "ODS":
          case "OTS":
          case "XLS":
          case "XLSM":
          case "XLSX":
          case "XLT":
          case "XLTM":
          case "XLTX":
          case "FODP":
          case "ODP":
          case "OTP":
          case "POT":
          case "POTM":
          case "POTX":
          case "PPS":
          case "PPT":
          case "PPTM":
          case "PPTX":
            win = window.open(
              `https://view.officeapps.live.com/op/view.aspx?src=${file.url}`,
              "_blank"
            );
            win.focus();
            break;
          default:
            this.$message({
              type: "info",
              message: this.$t("general_fileFormatIsNotSupported"),
            });
            this.fileUrl = "";
            this.type = "";
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.item {
  &__note {
    margin-bottom: 10px;
  }
  &__title {
    position: relative;
    font-size: 20px;
    color: #909399;
  }
  &__status {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &__content {
    margin-bottom: 10px;
  }
  &__file {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }
  &__btn {
    display: flex;
    justify-content: flex-end;
  }
}
/deep/.download-btn{
  a{
    color:#606266;
    &:hover{
      color:#66b1ff;
    }
  }
}
</style>
